import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 20v-16l-5 5","key":"svg-0"}],["path",{"d":"M16 20a4 4 0 0 0 4 -4v-8a4 4 0 1 0 -8 0v8a4 4 0 0 0 4 4","key":"svg-1"}]]

/**
 * IconNumber10
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbnVtYmVyLTEwIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik04IDIwdi0xNmwtNSA1IiAvPgogIDxwYXRoIGQ9Ik0xNiAyMGE0IDQgMCAwIDAgNCAtNHYtOGE0IDQgMCAxIDAgLTggMHY4YTQgNCAwIDAgMCA0IDQiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/number-10
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconNumber10 = createReactComponent('outline', 'number-10', 'Number10', __iconNode);

export default IconNumber10;